import { render, staticRenderFns } from "./WhyUs.vue?vue&type=template&id=4a0e925d&scoped=true"
import script from "./WhyUs.vue?vue&type=script&lang=js"
export * from "./WhyUs.vue?vue&type=script&lang=js"
import style0 from "./WhyUs.vue?vue&type=style&index=0&id=4a0e925d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e925d",
  null
  
)

export default component.exports